import { OtoIndividualPlace } from '../../lib/types/models/journey-place/oto-individual-place'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteOtoIndividualPlace = async (input: {
  journeyPlaceId: number
  otoIndividualPlaceId: number
}) => {
  return restApiClient
    .url(
      constructApiUrl(API.journeyPlaces.deleteOtoIndividualPlace.url, {
        id: input.journeyPlaceId,
        otoIndividualPlaceId: input.otoIndividualPlaceId
      })
    )
    .delete<OtoIndividualPlace>()
}
